import React from "react";

export interface MultiContentDialogProps {
  children: JSX.Element | null;
  visible?: boolean;
  handleModalState?: React.Dispatch<
    React.SetStateAction<MultiContentDialogProps>
  >;
}

export const MultiContentDialog: React.FC<MultiContentDialogProps> = ({
  children,
}) => {
  return children;
};
